export const iconFontAwesomeTravelHotelTruck = (
	<i className="fa-solid fa-truck"></i>
);
